export default __webpack_public_path__ + "static/media/building.b3c0dd66.svg";